// src/screens/LanguageSelect.jsx
import React from "react";
import { getLanguageSelectOptions } from "../data/languages";
import { Button, OptionCard, ScreenHeader, Stack } from "../components/ui";

const LANGUAGE_OPTIONS = getLanguageSelectOptions("de");

export default function LanguageSelect({ language, setLanguage, onContinue }) {
  const canContinue = Boolean(language);

  return (
    <>
      <ScreenHeader
        title="fluent! – Willkommen"
        subtitle="Welche Sprache möchtest du lernen?"
      />

      <Stack gap={2} equal>
        {LANGUAGE_OPTIONS.map((opt) => (
          <OptionCard
            key={opt.id}
            label={opt.label}
            hint={opt.unlocked ? undefined : "Bald verfügbar"}
            active={language === opt.id}
            disabled={!opt.unlocked}
            onClick={() => setLanguage(opt.id)}
          />
        ))}
      </Stack>

      <Stack gap={2} style={{ marginTop: "var(--fluent-space-5)" }}>
        <Button block onClick={onContinue} disabled={!canContinue}>
          Weiter
        </Button>
      </Stack>
    </>
  );
}
